module.exports = __webpack_public_path__ + "img/lighting-repair-replacement-01.f077a64e.jpg";